import { forwardRef } from "react";
import { ICONSAX_SIZE } from "../Iconsax/Iconsax.types.js";
import { TextSize } from "../Text/Text.types.js";
import { CountText, StyledBadge, StyledSpan } from "./Badge.style.js";
import type { BadgeProps, DefaultBadgeProps } from "./Badge.types.js";

const defaultProps: DefaultBadgeProps = {
    color: "primary",
    yOffset: "0",
    xOffset: "0",
    variant: "light",
};

export const Badge = forwardRef<HTMLDivElement, BadgeProps>(
    ({ children, icon: Icon, count, content, color, yOffset, xOffset, variant, ...props }, ref): JSX.Element => {
        return (
            <StyledBadge ref={ref} {...props}>
                {children}
                <StyledSpan
                    {...defaultProps}
                    {...props}
                    variant={variant ?? defaultProps.variant}
                    hasContent={!!content}
                    standalone={!children}
                    color={color ?? defaultProps.color}
                    yOffset={yOffset ?? defaultProps.yOffset}
                    xOffset={xOffset ?? defaultProps.xOffset}
                >
                    {Icon && <Icon size={ICONSAX_SIZE.LARGE} />}
                    {count && <CountText size={TextSize["X-SMALL"]}>{count}</CountText>}
                    {content}
                </StyledSpan>
            </StyledBadge>
        );
    },
);
